import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=b9e374f0&"
import script from "./TopicList.vue?vue&type=script&lang=js&"
export * from "./TopicList.vue?vue&type=script&lang=js&"
import style0 from "./TopicList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports